import type { MessageKey } from '@ralph/contracts'
import type { Messages } from '@/i18n/messages/en/index.ts'

/**
 * What the agents domain's refusals say, in Brazilian Portuguese (checked against the English
 * shape at compile time).
 *
 * *Camada* (f.) is the word for a definition layer throughout the studio, so *esta* and
 * *existe* agree with it. `If-Match` stays in English: it is the HTTP header the person is
 * sending, and a translated header name would name nothing (D-15).
 */
export const agents: Pick<Messages['errors'], Extract<MessageKey, `agents.${string}`>> = {
  'agents.not_available': ({ name }) => `Nenhum agente chamado “${name}” está disponível para você.`,

  'agents.layer_version_conflict': ({ expected, found }) =>
    `Outra pessoa alterou este agente enquanto você editava — você começou da versão ${expected} e ele já está na ${found}. Recarregue e refaça sua edição.`,

  'agents.layer_absent_for_if_match': () => 'Esta camada do agente ainda não existe. Crie-a sem uma versão If-Match.',

  // *Indisponível* é invariável em gênero, mas *este* concorda com *agente* (m.). As duas
  // frases são frases inteiras: a segunda não é a primeira com um rabicho colado.
  'agents.suspended': () => 'Este agente está indisponível no momento.',
  'agents.suspended_with_reason': ({ reason }) => `Este agente está indisponível no momento: ${reason}`
}
